import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/data/services/auth.service';
import { UserUtil } from 'src/app/data/utils/user.utils';

@Component({
  selector: 'app-login-bypass',
  templateUrl: './login-bypass.component.html',
  styleUrls: ['./login-bypass.component.scss']
})
export class LoginBypassComponent implements OnInit {

  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private userUtil: UserUtil,
    private router: Router,
  ) { }

  async ngOnInit(): Promise<void> {
    const token = this.activatedRoute.snapshot.queryParamMap.get('accessToken');
    const refreshToken = this.activatedRoute.snapshot.queryParamMap.get('refreshToken');
    try {
      const result = await this.authService.loginByPass(token!, refreshToken!);

      if (result.navigateTo === 'select-tenant') {
        await this.router.navigate([result.navigateTo]);
      } else {
        this.routeTo();
      }
    } catch (error) {
      console.log(error);
      this.router.navigate(['login']);
    }
  }

    private routeTo(): void {
      let route = 'news-list';
      if (this.userUtil.isFuncionarioProfile()) {
        route = 'users';
      }
      if (this.userUtil.isProfessorProfile()) {
        route = 'chat';
      }
      this.router.navigate([route]);
    }
}
